"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
// @ts-ignore-next-line importsNotUsedAsValues
require("react");
const Dialog_1 = tslib_1.__importDefault(require("./Dialog"));
const InfoDialog = (props) => {
    const { content, className } = props, remainingProps = tslib_1.__rest(props, ["content", "className"]);
    const dialogClassName = `${className ? className : ''} info-dialog`;
    return (0, jsx_runtime_1.jsx)(Dialog_1.default, Object.assign({}, remainingProps, { body: content, className: dialogClassName }));
};
exports.default = InfoDialog;
